import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ComplianceSteps } from 'src/app/interfaces/compliance-steps';
import { ViveProgressStatus } from 'src/app/interfaces/vive-progress-status';
import { ViveProgressSubStatus } from 'src/app/interfaces/vive-progress-substatus';

export class ViveProgressForm extends FormGroup<{
  id: FormControl<undefined | number>;
  CompanyVendorId: FormControl<undefined | number | null>;
  CompanyId: FormControl<undefined | number>;
  VendorId: FormControl<undefined | number>;
  ClientRegisteredVendorId: FormControl<undefined | number>;
  UserId: FormControl<undefined | number>;
  type: FormControl<ComplianceSteps | undefined>;
  status: FormControl<ViveProgressStatus | null | undefined>;
  statusDate: FormControl<Date | undefined>;
  subStatus: FormControl<ViveProgressSubStatus | undefined>;
  ticketUrl: FormControl<string | undefined>;
  isOverrided: FormControl<boolean | undefined>;
  overrideDate: FormControl<Date | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      CompanyVendorId: new FormControl<undefined | number | null>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      CompanyId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      VendorId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ClientRegisteredVendorId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      UserId: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      type: new FormControl<ComplianceSteps | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      status: new FormControl<ViveProgressStatus | null | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      ),
      statusDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      subStatus: new FormControl<ViveProgressSubStatus | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ticketUrl: new FormControl<string | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      isOverrided: new FormControl<boolean | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      overrideDate: new FormControl<Date | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      )
    });
  }
}
